import PropTypes from 'prop-types';
import { Stack, Typography, Box, Accordion, AccordionSummary, Button } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ContactForm from './ContactForm';
import Iconify from '../iconify/Iconify';

ContactListForm.propTypes = {
  formValue: PropTypes.object,
  setFormValue: PropTypes.func,
  contactTypes: PropTypes.array,
  id: PropTypes.string
}

export default function ContactListForm({ formValue, setFormValue, contactTypes, id = "contacts" })
{  
  return <Box sx={{ border: "solid thin rgb(43 45 47 / 24%)" }}>
    <Accordion>
      <AccordionSummary expandIcon={<ArrowDownwardIcon />}>
        <Typography component="span">Contacts</Typography>
      </AccordionSummary>
      <Stack sx={{ mx: 2, mb: 2 }} spacing={1}>
        {(formValue[id] ?? []).map((contact, index) => <ContactForm
          key={index}
          contactTypes={contactTypes}
          contactData={contact}
          setFormValue={setFormValue}
          index={index}
          deleteContact={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setFormValue(form => {
              form[id] = form[id].filter((contact, deleteIndex) => deleteIndex !== index );
              return { ...form };
            })
          }}
          title={contact.email ? `${contact.firstName ?
            `${contact.firstName} ${(contact.lastName ? ` ${contact.lastName} ` : "")}(${contact.email})` : contact.email}`
            : "New Contact"}
        />)}
        <Box alignSelf="center">
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            sx={{ mt: 2 }}
            onClick={() => setFormValue(form => {
              form[id] = [...(form[id] ?? []), {}];
              return { ...form };
            })}
            color="primary"
            size="medium">
            <Typography> Add New Contact</Typography>
          </Button>
        </Box>
      </Stack>
    </Accordion>
  </Box>;
}
